import { Location } from "@angular/common";
import { Component, OnInit, ViewEncapsulation, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PartnerDTO } from "@shared/model/partnerDTO";
import { ApiService } from "@shared/services/api.service";
import { TemplateService } from "@shared/services/template/template.service";
import { UsersService } from "@shared/services/users/users.service";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";
import { take } from "rxjs/operators";

@Component({
	selector: "app-private-partner",
	templateUrl: "./private-partner.component.html",
	styleUrl: "./private-partner.component.scss",
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class PrivatePartnerComponent implements OnInit {
	private activatedRoute = inject(ActivatedRoute);
	utils = inject(ClickarUtilsService);
	private userService = inject(UsersService);
	private apiService = inject(ApiService);
	private templateService = inject(TemplateService);
	private location = inject(Location);

	private idTemplate: any;
	size: number[] = [];
	partners: PartnerDTO[];
	partner: PartnerDTO;
	slideSize = 0;
	offset = 2;

	constructor() {
		this.activatedRoute.queryParams.subscribe(value1 => {
			this.idTemplate = value1["idTemplate"];
			if (this.idTemplate) {
				this.templateService.getPartnersUsingGET().subscribe(partners => {
					this.partner = partners.filter(
						p => p.idTemplate == this.idTemplate
					)[0];
				})
			}
		});
	}

	ngOnInit() {
		this.userService.getProfileOfLoggedUser()
			.pipe(take(1))
			.subscribe(value => {
				this.apiService
					.getPartnersUsingGET(value.idMarket)
					.subscribe(value => {
						this.partners = value;
						this.size = [];
						if (!this.partners.length) {
							this.slideSize = 0;
						} else if (this.partners.length < this.offset) {
							this.slideSize = 1;
							this.size.push(1);
						} else {
							this.slideSize = Math.ceil(
								this.partners.length / this.offset
							);
							for (let i = 0; i < this.slideSize; i++) {
								this.size.push(i);
							}
						}
					});
			});
	}

	selectedPartner(partner: PartnerDTO) {
		this.partner = partner;
		window.scrollTo(0, 0);
	}

	getStars(rating: number | null | undefined): ("full" | "half" | "empty")[] {
		const stars: ("full" | "half" | "empty")[] = [],
			value = Math.max(0, Math.min(5, rating ?? 0)),
			fullStars = Math.floor(value),
			hasHalfStar = value - fullStars >= 0.25 && value - fullStars < 0.75,
			roundedFullStars = value - fullStars >= 0.75 ? fullStars + 1 : fullStars;

		for (let i = 0; i < 5; i++) {
			if (i < fullStars) {
				stars.push("full");
			}
			else
				if (i === fullStars && hasHalfStar) {
					stars.push("half");
				}
				else
					if (i < roundedFullStars) {
						stars.push("full");
					}
					else {
						stars.push("empty");
					}
		}
		return stars;
	}

	goBack() {
		!this.partner || this.idTemplate ? this.location.back() : this.partner = null
	}
}